let url = "";

url = process.env.REACT_APP_BASE_URL;
// url = "http://192.168.29.48:8000/api/v1";

export const BACKEND_BASE_URL = url;
